<template>
  <div class="app-layout-events"
       :class="{
          bioprom: type === 'bioprom',
          innofood: type === 'innofood',
          biotechmed: type === 'biotechmed',
          layout2: layout2State
       }"
  >
    <div v-if="isNewVersion">
      <div v-if="filterByTracksAndHalls">
        <div class="app-layout-events__filters app-layout-events__filters--days">
          <button @click="setAllDays" class="app-layout-events__button"
                  :class="[this.activeDate.length === 0 ? 'is-active' : '']">
            {{ allDaysText }}
          </button>
          <AppCardFilter v-for="(filter, idx) in dayFilters"
                         :key="`day${idx}`" :data="filter" :isDate=true
                         @change="setActiveDate" type="checkbox"/>
        </div>

        <div class="app-layout-events__tabs" v-if="tabTrek">
          <div class="app-layout-events__tab" :class="activeFilter === 'trek' ? 'is-active' : ''"
               @click="setActiveFilter('trek')" v-if="tabTrek"><span>{{ tabTrek }}</span></div>

          <div class="app-layout-events__tab" :class="activeFilter === 'hall' ? 'is-active' : ''"
               @click="setActiveFilter('hall')" v-if="tabTrek"><span>{{ tabHall }}</span></div>
        </div>

        <div class="app-layout-events__filters" v-show="activeFilter === 'trek'">
          <div class="app-layout-events__filters-actions is-tracks">
            <button @click="setAllTreks"
                    :class="[activeTrekId ? '' : 'is-active']"
                    class="app-layout-events__button app-layout-events__button--tracks">
              {{ allTracksText }}
            </button>
          </div>

          <AppCardFilter v-for="(filter, idx) in trekFilters"
                         :key="`trek${idx}`" :data="filter" @change="setActiveTrekId"/>
        </div>

        <!-- фильтр по залам -->
        <div class="app-layout-events__filters-wrapper" v-if="hallFiltersSingle"
             v-show="activeFilter === 'hall'"
        >

          <div class="app-layout-events__filters app-layout-events__filters--halls">
            <div class="app-layout-events__filters-actions">
              <button @click="setAllHallsSingle"
                      :class="[activeHallSingle ? '' : 'is-active']"
                      class="app-layout-events__button app-layout-events__button--halls">
                {{ allHallsText }}
              </button>
            </div>

            <AppCardFilter v-for="(filter, idx) in hallFiltersSingle" :isHall=true
                           :key="`hall${idx}`" :data="filter" @change="setActiveHallSingle"/>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="app-layout-events__filters">
          <button @click="setAllDays" class="app-layout-events__button"
                  :class="[this.activeDate.length === 0 ? 'is-active' : '']">
            {{ allDaysText }}
          </button>
          <AppCardFilter v-for="(filter, idx) in dayFilters"
                         :key="`day${idx}`" :data="filter" :isDate=true
                         @change="setActiveDate" type="checkbox"/>
        </div>

        <!-- фильтр по залам -->
        <div class="app-layout-events__filters-wrapper" v-if="hallFilters.length">
          <div class="app-layout-events__filters-actions">
            <button @click="setAllHalls"
                    class="app-layout-events__button app-layout-events__button--halls">
              {{ allHallsText }}
            </button>

            <button @click="resetHalls"
                    v-if="this.activeHall.length !== 0"
                    class="app-layout-events__button app-layout-events__button--halls is-reset">
              {{ resetHallsText }}
            </button>
          </div>
          <div class="app-layout-events__filters app-layout-events__filters--halls">
            <AppCardFilter v-for="(filter, idx) in hallFilters"
                           :key="`hall${idx}`" :data="filter"
                           @change="setActiveHall" type="checkbox"/>
          </div>
        </div>
          <div class="app-layout-events__filters" v-if="!isNewVersion">
            <AppCardFilter v-for="(filter, idx) in trekFilters"
                           :key="`trek${idx}`" :data="filter" @change="setActiveTrekId"/>
          </div>
        </div>
      </div>
    <div v-else>
      <div class="app-layout-events__filters">
        <button @click="setAllDays" class="app-layout-events__button"
          :class="[this.activeDate.length === 0 ? 'is-active' : '']">
          {{ allDaysText }}
        </button>
        <AppCardFilter v-for="(filter, idx) in dayFilters"
                      :key="`day${idx}`" :data="filter" :isDate=true
                      @change="setActiveDate" type="checkbox"/>
      </div>
      <div class="app-layout-events__buttons">
        <button @click="setAllTreks" class="app-layout-events__button-text treks"
        :class="[this.activeTrekId === null ? 'is-active' : '']">
        {{ allTreksText }}
        </button>
        <button @click="setAllTreks"
          class="app-layout-events__button-text reset"
          :class="[this.activeTrekId === null ? '' : 'is-active']"> {{ resetText }} </button>
      </div>
      <div class="app-layout-events__filters">
        <AppCardFilter v-for="(filter, idx) in trekFilters"
                       :key="`trek${idx}`" :data="filter" @change="setActiveTrekId"/>

      </div>
    </div>
    <ul class="app-layout-events__items" v-if="events">
      <li class="app-layout-events__item" v-for="(item, idx) in events" :key="`event${idx}`">
        <AppCardEvent :data="item"
                      v-show="filteredEvents.includes(item.id)"
                      @event-open="eventOpen"
                      @favorites="toggleFavorites" />
      </li>

      <!-- если не найдено -->
      <div v-if="!filteredEvents.length" class="app-layout-events__empty">
        <div class="app-layout-events__empty-text">{{ emptyMessage }}</div>
      </div>
    </ul>
    <div class="app-layout-events__actions">
      <div class="app-layout-events__action">
        <AppButton :data="downloadAll" v-if="downloadAll"/>
      </div>
      <!-- почему @click на div, а не на кнопке? -->
      <div class="app-layout-events__action" v-if="downloadFavorites"
           @click="downloadFavoritesEvents">
        <AppButton :loading=loading :data="downloadFavorites"/>
      </div>
    </div>
    <AppLayoutEvent :data="activeEvent" :newVersion="filterByTracksAndHalls ? false : isNewVersion"
                    @event-close="eventClose" v-if="eventShow"/>
  </div>
</template>
<script>

import AppLayoutEvent from '@/components/app-layout-event/app-layout-event.vue';
import AppCardEvent from '@/components/app-card-event/app-card-event.vue';
import AppCardFilter from '@/components/app-card-filter/app-card-filter.vue';
import AppButton from '@/components/app-button/app-button.vue';
import _get from 'lodash.get';

export default {
  name: 'AppLayoutEvents',
  components: {
    AppLayoutEvent,
    AppCardEvent,
    AppCardFilter,
    AppButton,
  },
  props: ['data', 'isNewVersion', 'filterByTracksAndHalls', 'lang', 'type', 'year'],
  data() {
    return {
      loading: false,
      activeTrekId: null,
      activeDate: [],
      activeHall: [],
      activeHallSingle: null,
      activeEventId: null,
      activeFilter: 'trek',
      filteredEvents: [],
      favoriteEvents: [],
      eventShow: false,
      events: [],
      treksFilterArray: [], // массив треков из отдельного справочника
      downloadAll: null,
      downloadFavorites: null,
      tabDay: null,
      tabTrek: null,
      tabHall: null,
      emptyMessage: null,
      allHallsText: null,
      resetHallsText: null,
      allTracksText: null,
    };
  },
  methods: {
    setActiveFilter(key) {
      this.activeFilter = key;
      this.filterEvents();
    },
    setActiveTrekId(e) {
      this.activeTrekId = e.target.id;
      this.filterEvents();
    },
    setActiveDate(e) {
      this.activeDate = [e.target.value];

      this.filterEvents();
    },
    setActiveHall(e) {
      if (this.hallsSet.has('')) {
        this.hallsSet.delete('');
      }
      if (this.hallsSet.has(null)) {
        this.hallsSet.delete(null);
      }

      if (this.hallsSet.has(e.target.value)) {
        const set = this.hallsSet;
        set.delete(e.target.value);
        this.activeHall = [...set];
      } else {
        this.activeHall.push(e.target.value);
      }

      if (this.activeHall.length === 1 && this.activeHall[0].length < 1) {
        this.resetHalls();
        return;
      }

      this.filterEvents();
    },
    setActiveHallSingle(e) {
      this.activeHallSingle = e.target.value;
      this.filterEvents();
    },
    setAllDays() {
      this.activeDate = [];
      this.filterEvents();
    },
    setAllTreks() {
      this.activeTrekId = null;
      this.filterEvents();
    },
    setAllHalls() {
      this.events.forEach((ev) => {
        if (!this.hallsSet.has(ev.hall)) {
          this.activeHall.push(ev.hall);
        }
      });
      this.filterEvents();
    },
    setAllHallsSingle() {
      this.activeHallSingle = null;
      this.hallSingleState = true;
      this.filterEvents();
    },
    resetHalls() {
      this.activeHall = [];
      this.filterEvents();
    },
    filterEvents() {
      if (this.activeHallSingle || this.hallSingleState) {
        this.filteredEvents = this.events
          .filter((
            (ev) => this.checkDate(ev.date)
              && this.checkHallSingle(ev.hall)
              && this.checkTrek(ev.trek_id, ev.treks)))
          .map((ev) => ev.id);
      } else {
        this.filteredEvents = this.events
          .filter((
            (ev) => this.checkDate(ev.date)
              && this.checkHall(ev.hall)
              && this.checkTrek(ev.trek_id, ev.treks)))
          .map((ev) => ev.id);
      }
    },
    eventOpen(id) {
      this.activeEventId = id;
      this.eventShow = true;
      this.disableScroll();
      window.location.hash = `event-${this.activeEventId}`;
    },

    eventClose() {
      this.eventShow = false;
      window.history.pushState('', '', `${window.location.pathname}${window.location.search}`);
      this.enableScroll();
      // window.location.hash = '';
    },

    toggleFavorites(id) {
      if (this.favoriteEvents.indexOf(id) !== -1) {
        const index = this.favoriteEvents.indexOf(id);
        this.favoriteEvents.splice(index, 1);
      } else {
        this.favoriteEvents.push(id);
      }

      localStorage.favoriteEvents = JSON.stringify(this.favoriteEvents);
      this.events.forEach((ev) => {
        // eslint-disable-next-line no-param-reassign
        ev.favorites = this.favoriteEvents.includes(ev.id);
      });
    },

    async downloadFavoritesEvents() {
      if (this.loading) return;
      if (!this.favoriteEvents.length) return;

      const config = {
        params: {
          id: this.favoriteEvents,
          lang: this.lang,

          // значения по умолчанию
          // year: '2024',
          // type: 'tashkent',
        },
      };

      if (this.year) {
        config.params.year = this.year;
      }

      if (this.type) {
        config.params.type = this.type;
      }

      try {
        this.loading = true;
        const result = await this.$api.get('/api/favorites/getPdf', config);
        if (result) {
          const url = _get(result, 'data.data.record.href', null);
          if (url) {
            window.open(url, '_blank').focus();
          }
          this.loading = false;
        }
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    popState() {
      const { hash } = window.location;
      if (hash) {
        const hashArr = hash.split('-');
        this.eventOpen(hashArr[1]);
      } else {
        this.eventClose();
      }
    },

    disableScroll() {
      const { body } = document;
      if (body.classList.contains('scroll-disabled')) return;
      body.classList.remove('scroll-enabled');
      body.classList.add('scroll-disabled');
      const scrollY = window.pageYOffset;
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}px`;
    },

    enableScroll() {
      const { body } = document;
      if (body.classList.contains('scroll-enabled')) return;
      body.classList.remove('scroll-disabled');
      body.classList.add('scroll-enabled');
      const scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    },
    checkDate(date) {
      if (this.daysSet.size > 0) {
        return this.daysSet.has(date);
      }
      return true;
    },
    checkHall(hall) {
      if (this.hallsSet.size > 0) {
        return this.hallsSet.has(hall);
      }
      return true;
    },
    checkHallSingle(hall) {
      if (this.activeHallSingle) {
        return `${this.activeHallSingle}` === hall;
      }
      return true;
    },
    checkTrek(trek, treks) {
      if (this.activeTrekId) {
        if (treks) {
          const treksList = Array.from(Object.values(treks));
          return treksList.some((el) => el.trek_id === this.activeTrekId);
        }
        return `${this.activeTrekId}` === trek;
      }
      return true;
    },
  },
  computed: {
    daysSet() {
      return new Set(this.activeDate);
    },
    hallsSet() {
      return new Set(this.activeHall);
    },
    dayFilters() {
      const filters = [];
      const dates = [];
      if (this.events.length) {
        this.events.forEach((event, idx) => {
          const el = {};
          if (this.activeDate.length && this.checkDate(event.date)) {
            el.active = true;
          } else if (!this.activeDate && idx === 0) {
            el.active = true;
          }
          el.value = event.date;
          el.text = `${event.dateNumber} ${event.dateLabel} — ${event.day}`;
          el.name = 'day';
          if (dates.includes(el.value)) return;
          dates.push(el.value);
          filters.push(el);
        });
      }
      return filters;
    },
    trekFilters() {
      const filters = [];
      const treks = [];
      // если передается справочник треков
      if (this.treksFilterArray.length > 0) {
        this.treksFilterArray.forEach((item) => {
          const el = {};
          if (this.activeTrekId && item.trek_id === this.activeTrekId) {
            el.active = true;
          }
          el.color = item.trek_color;
          el.id = item.trek_id;
          el.text = item.name;
          el.value = item.name;
          el.name = 'trek';
          if (treks.includes(el.value) || !el.value) return;
          treks.push(el.value);
          filters.push(el);
        });
      } else if (this.events.length) {
        this.events.forEach((event) => {
          const el = {};
          if (this.activeTrekId && event.trek_id === this.activeTrekId) {
            el.active = true;
          }
          el.color = event.trek_color;
          el.id = event.trek_id;
          el.text = event.trek;
          el.value = event.trek;
          el.name = 'trek';
          if (treks.includes(el.value) || !el.value) return;
          treks.push(el.value);
          filters.push(el);
        });

        if (this.layout2State) {
          // Поиск индексов "КОСМЕТИК КОМПОНЕНТ" и "INNOFOOD"
          const cosmetikIndex = filters.findIndex((filter) => filter.value.toLowerCase() === 'косметик компонент');
          const innofoodIndex = filters.findIndex((filter) => filter.value.toLowerCase() === 'innofood');
          const cosmetikIndexEn = filters.findIndex((filter) => filter.value.toLowerCase() === 'cosmetics component');

          // Обмен местами элементов
          if (cosmetikIndex !== -1 && innofoodIndex !== -1) {
            const temp = filters[cosmetikIndex];
            filters[cosmetikIndex] = filters[innofoodIndex];
            filters[innofoodIndex] = temp;
          } else if (cosmetikIndexEn !== -1 && innofoodIndex !== -1) {
            const temp = filters[cosmetikIndexEn];
            filters[cosmetikIndexEn] = filters[innofoodIndex];
            filters[innofoodIndex] = temp;
          }
        }
      }
      return filters;
    },
    hallFilters() {
      const filters = [];
      const halls = [];
      if (this.events.length) {
        this.events.forEach((event, idx) => {
          const el = {};
          if (this.isNewVersion) {
            if (this.activeHall.length && this.checkHall(event.hall)) {
              el.active = true;
            } else if (!this.activeHall && idx === 0) {
              el.active = true;
            }
          } else if (this.activeHall && event.hall === this.activeHall) {
            el.active = true;
          } else if (!this.activeHall && idx === 0) {
            el.active = true;
          }
          el.value = event.hall;
          el.text = `${event.hall && event.hall.length ? event.hall : ''}`;
          el.name = 'hall';
          if (halls.includes(el.value) || el.text.length < 1) return;
          halls.push(el.value);
          filters.push(el);
        });
      }
      filters.sort();
      return filters;
    },
    hallFiltersSingle() {
      const filters = [];
      const halls = [];
      if (this.events.length) {
        this.events.forEach((event) => {
          const el = {};
          if (this.activeHallSingle && event.hall === this.activeHallSingle) {
            el.active = true;
          }
          el.value = event.hall;
          el.text = `${event.hall && event.hall.length ? event.hall : ''}`;
          el.name = 'hall';
          if (halls.includes(el.value) || el.text.length < 1) return;
          halls.push(el.value);
          filters.push(el);
        });
      }
      filters.sort((a, b) => a.value.localeCompare(b.value));
      return filters;
    },
    activeEvent() {
      let active = [];
      if (this.activeEventId) {
        active = this.events.filter((ev) => ev.id === this.activeEventId);
      }
      return active[0];
    },

    allDaysText() {
      return this.lang === 'ru' ? 'Все дни' : 'All days';
    },
    allTreksText() {
      return this.lang === 'ru' ? 'Выбрать все треки' : 'Select all tracks';
    },
    resetText() {
      return this.lang === 'ru' ? 'Сбросить выбранное' : 'Reset selected';
    },

    layout2State() {
      return this.type === 'bioprom' || this.type === 'innofood' || this.type === 'biotechmed';
    },
  },

  mounted() {
    const { hash } = window.location;
    if (hash) {
      const hashArr = hash.split('-');
      this.eventOpen(hashArr[1]);
    }
    window.addEventListener('popstate', this.popState);
    this.events = this.data.events.items;
    // если есть справочник треков
    if (this.data && this.data.trek) {
      this.treksFilterArray = Array.from(Object.values(this.data.trek));
    }
    if (this.events.length) {
      this.events.forEach((ev) => {
        this.$set(ev, 'favorites', false);
        this.$set(ev, 'inFavorites', this.data.favorites.inFavorites);
        this.$set(ev, 'outFavorites', this.data.favorites.outFavorites);
      });
      if (localStorage.favoriteEvents) {
        this.favoriteEvents = JSON.parse(localStorage.favoriteEvents);

        this.events.forEach((ev) => {
          // eslint-disable-next-line no-param-reassign
          ev.favorites = this.favoriteEvents.includes(ev.id);
        });
      }
    }
    this.tabDay = this.data.tabDay;
    this.tabTrek = this.data.tabTrek;
    this.tabHall = this.data.tabHall || 'По площадкам';
    this.downloadAll = this.data.downloadAll;
    this.downloadFavorites = this.data.downloadFavorites;
    // this.activeTrekId = this.events[0].trek_id;
    this.emptyMessage = this.data.empty_message || 'К сожалению, по вашему запросу ничего не найдено';
    this.allHallsText = this.data.filters.hall.label || 'Выбрать все площадки';
    this.resetHallsText = this.data.filters.hall.clear || 'Сбросить выбранное';

    this.allTracksText = 'Выбрать все треки';
    if (this.data.filters.trek) {
      this.allTracksText = this.data.filters.trek.label || 'Выбрать все треки';
    }

    // для старой версии первая дата активна по умолчанию
    // if (!this.isNewVersion) {
    //   this.activeDate = this.events[0].date;
    // }
    // if (this.isNewVersion) {
    //   this.activeDate = [this.events[0].date];
    // } else {
    //   this.activeDate = this.events[0].date;
    // }

    this.filterEvents();
  },

  beforeDestroy() {
    window.history.pushState('', '', `${window.location.pathname}${window.location.search}`);
    window.removeEventListener('popstate', this.popState);
  },
};

</script>

<style lang="scss">
@import "app-layout-events";
</style>
